module.exports = __webpack_public_path__ + "img/default.3cd1a24c.png";